(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tp-visual-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tp-visual-navigation')) {
    customElements.define('tp-visual-navigation', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = null;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.groupLinks = [...this.querySelectorAll('[data-tp-group]')];
        this.categoryLinks = [...this.querySelectorAll('[data-tp-category]')];
        [...this.groupLinks, ...this.categoryLinks].forEach(link => link.setAttribute('role', 'button'));
        this.groups = [...this.querySelectorAll('[data-tp-panel-group]')];
        this.content = this.querySelector('.tp-menu-content');
        this.preview = this.querySelector('.tp-menu-preview');
        this.scrollSections = this.groups.flatMap(panel => {
          const group = panel.dataset.tpPanelGroup;
          return [{ panel, group }, ...[...panel.querySelectorAll('[data-tp-panel-category]')]
            .filter(section => this.categoryLinks.some(link => link.dataset.tpParent === group && link.dataset.tpCategory === section.dataset.tpPanelCategory))
            .map(section => ({ panel: section, group, category: section.dataset.tpPanelCategory }))];
        });
        this.select(this.dataset.defaultGroup || this.groups[0]?.dataset.tpPanelGroup, undefined, this.dataset.mode === 'mobile' ? 'none' : 'auto');
        this.setAttribute('data-ready', '');
        this.addEventListener('click', event => {
          const link = event.target.closest('[data-tp-group], [data-tp-category]');
          if (!link || !this.contains(link) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          this.select(link.dataset.tpGroup || link.dataset.tpParent, link.dataset.tpCategory);
        }, options);
        this.addEventListener('pointerover', event => {
          if (event.pointerType !== 'mouse' || this.dataset.mode !== 'desktop') return;
          const category = event.target.closest('[data-tp-category]');
          if (category && !category.contains(event.relatedTarget)) this.select(category.dataset.tpParent, category.dataset.tpCategory);
          this.showPreview(event.target.closest('[data-tp-image]'));
        }, options);
        this.addEventListener('pointerout', event => {
          const product = event.target.closest('[data-tp-image]');
          if (product && !product.contains(event.relatedTarget)) this.hidePreview();
        }, options);
        this.addEventListener('focusin', event => this.showPreview(event.target.closest('[data-tp-image]')), options);
        this.addEventListener('focusout', () => this.hidePreview(), options);
        this.addEventListener('pointerleave', () => this.hidePreview(), options);
        this.content.addEventListener('scroll', () => {
          this.hidePreview();
          if (this.dataset.mode !== 'mobile' || this.scrollFrame != null) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            this.updateActiveFromScroll();
          });
        }, { ...options, passive: true });
        this.addEventListener('keydown', event => {
          const link = event.target.closest('[data-tp-group], [data-tp-category]');
          if (link && event.key === ' ') { event.preventDefault(); link.click(); }
        }, options);
        const desktop = this.closest('desktop-navigation');
        if (desktop) {
          const item = this.closest('.header__linklist-item');
          const trigger = item.querySelector('.header__linklist-link');
          const dropdown = this.closest('.mega-menu');
          trigger.addEventListener('keydown', event => {
            if (!['ArrowDown', 'Enter', ' '].includes(event.key)) return;
            event.preventDefault();
            trigger.setAttribute('aria-expanded', 'true');
            dropdown.removeAttribute('hidden');
            this.groupLinks[0]?.focus();
          }, options);
          item.addEventListener('keydown', event => {
            if (event.key !== 'Escape') return;
            event.preventDefault();
            dropdown.setAttribute('hidden', '');
            trigger.setAttribute('aria-expanded', 'false');
            this.hidePreview();
            trigger.focus();
          }, options);
          item.addEventListener('focusout', event => {
            if (item.contains(event.relatedTarget)) return;
            dropdown.setAttribute('hidden', '');
            trigger.setAttribute('aria-expanded', 'false');
          }, options);
        }
        const drawer = this.closest('mobile-navigation');
        if (drawer) {
          let initialized = false;
          const onOpen = () => {
            if (!initialized) {
              this.select(this.dataset.defaultGroup || this.groups[0]?.dataset.tpPanelGroup, undefined, 'auto');
              initialized = true;
            }
            this.updateActiveFromScroll();
          };
          drawer.addEventListener('mobile-nav:open', onOpen, options);
          if (drawer.open) onOpen();
          this.breakpoint = matchMedia('(min-width: 1200px)');
          this.breakpoint.addEventListener('change', event => { if (event.matches && drawer.open) drawer.open = false; }, options);
        }
      }
      disconnectedCallback() {
        this.abortController?.abort();
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = null;
        this.hidePreview();
      }
      select(group, category, behavior = 'smooth') {
        if (!this.groups.some(panel => panel.dataset.tpPanelGroup === group)) group = this.groups[0]?.dataset.tpPanelGroup;
        const mobile = this.dataset.mode === 'mobile';
        const activePanel = this.groups.find(panel => panel.dataset.tpPanelGroup === group);
        this.groups.forEach(panel => {
          const active = panel.dataset.tpPanelGroup === group;
          panel.hidden = !mobile && !active;
          panel.querySelectorAll('[data-tp-panel-category]').forEach(collection => {
            collection.hidden = Boolean(!mobile && category && collection.dataset.tpPanelCategory !== category);
          });
          panel.querySelector('.tp-menu-collections')?.toggleAttribute('data-filtered', Boolean(!mobile && category));
        });
        this.setActive(group, category);
        if (this.content && behavior !== 'none') {
          const target = mobile && activePanel
            ? [...activePanel.querySelectorAll('[data-tp-panel-category]')].find(panel => panel.dataset.tpPanelCategory === category) || activePanel
            : null;
          if (target) {
            const top = Math.max(0, target.getBoundingClientRect().top - this.groups[0].getBoundingClientRect().top);
            if (behavior === 'auto' || matchMedia('(prefers-reduced-motion: reduce)').matches) {
              this.content.scrollTop = top;
            } else {
              this.content.scrollTo({ top, behavior });
            }
          } else {
            this.content.scrollTop = 0;
          }
        }
        this.hidePreview();
      }
      setActive(group, category) {
        this.groupLinks.forEach(link => {
          const active = link.dataset.tpGroup === group;
          link.setAttribute('aria-expanded', String(this.dataset.mode === 'mobile' || active));
          link.toggleAttribute('data-active', active);
          link.parentElement.toggleAttribute('data-active', active);
          if (active && !category) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
        });
        this.categoryLinks.forEach(link => {
          const active = link.dataset.tpParent === group && link.dataset.tpCategory === category;
          if (active) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
        });
      }
      updateActiveFromScroll() {
        if (!this.content?.clientHeight || !this.scrollSections.length) return;
        let current = this.scrollSections[0];
        const origin = this.groups[0].getBoundingClientRect().top;
        for (const section of this.scrollSections) {
          if (section.panel.getBoundingClientRect().top - origin > this.content.scrollTop + 2) break;
          current = section;
        }
        const maxScroll = this.content.scrollHeight - this.content.clientHeight;
        if (maxScroll > 0 && this.content.scrollTop >= maxScroll - 2) current = this.scrollSections[this.scrollSections.length - 1];
        this.setActive(current.group, current.category);
      }
      showPreview(link) {
        if (!link || this.dataset.mode !== 'desktop' || !matchMedia('(hover: hover)').matches) return;
        const image = this.preview.querySelector('img');
        image.src = link.dataset.tpImage;
        const bounds = link.getBoundingClientRect();
        this.preview.style.left = `${Math.max(8, bounds.left - 128)}px`;
        this.preview.style.top = `${Math.max(8, Math.min(bounds.top - 26, innerHeight - 124))}px`;
        this.preview.hidden = false;
      }
      hidePreview() {
        if (this.preview) this.preview.hidden = true;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
